import { render, staticRenderFns } from "./company-brand.vue?vue&type=template&id=edb07d14&scoped=true&"
import script from "./company-brand.vue?vue&type=script&lang=js&"
export * from "./company-brand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb07d14",
  null
  
)

export default component.exports